
<script>
import moment from 'moment'
import starIcon from '@/assets/images/icons/star.svg?inline'

export default {
  name: 'lk-sale',
  components: {
    starIcon
  },
  computed: {
    sale() {
      return this.$store.getters['lk/getSale']
    }
  },
  methods: {
    formatDate: date => moment.unix(date).format('DD.MM.YYYY'),
  }
}
</script>

<template>
  <div
    v-if="sale && sale.checkInDate"
    class="lk__content-item lk__sale"
  >
    <div class="lk__content-item-header">
      <h2>Предложение дня</h2>
    </div>
    <div class="lk__content-item-main">
      <div class="lk__sale-preview">
        <img
          v-if="sale.image"
          :src="sale.image"
          class="lk__sale-image"
        >
        <img
          v-else
          src="@/assets/images/default.jpg"
          class="lk__sale-image"
        >
        <img
          v-if="!sale.isHotel"
          :src="sale.flag"
          alt=""
          class="lk__sale-flag"
        >
      </div>
      <h3
        class="lk__sale-title"
      >
        {{ sale.name }}
      </h3>
      <div class="lk__sale-description">
        <div
          class="lk__sale-description-info"
          :class="{ 'full-width': !sale.isHotel }"
        >
          <p>Заезд {{ formatDate(sale.checkInDate) }}, {{ sale.duration }} ночей</p>
          <span>{{ sale.description }}</span>
        </div>
        <div
          v-if="sale.isHotel"
          class="lk__sale-description-data"
        >
          <div
            v-if="sale.rating"
            class="search-card__rating"
          >
            {{ sale.rating }}/100
          </div>
          <div class="lk__sale-stars">
            <starIcon
              v-for="i in sale.category"
              :key="`star_${i}`"
            />
          </div>
          <span>{{ sale.city }}</span>
        </div>
      </div>
      <div
        v-if="sale.isHotel"
        class="lk__sale-links"
      >
        <router-link
          :to="{
            name: 'Cart',
            params: {
              id: sale.redirectInfo.cart.placeId,
              service: 'hotels'
            },
            query: {
              ...sale.redirectInfo.cart,
              checkInDate: formatDate(sale.redirectInfo.cart.checkInDate)
            }
          }"
          class="rex-btn rex-btn--bold rex-btn--sm active"
        >
          <span>от 1200$</span>
        </router-link>
        <router-link
          :to="{
            name: 'HotelsSearch',
            query: {
              ...sale.redirectInfo.search,
              checkInDate: formatDate(sale.redirectInfo.search.checkInDate)
            }
          }"
          class="rex-btn rex-btn--bold rex-btn--sm rex-btn--gray active"
        >
          <span>Отели на эту дату</span>
        </router-link>
      </div>
      <div
        v-if="!sale.isHotel"
        class="lk__sale-link"
      >
        <router-link
          :to="{
            name: 'HotelsSearch',
            query: {
              ...sale.redirectInfo.search,
              checkInDate: formatDate(sale.redirectInfo.search.checkInDate)
            }
          }"
          class="rex-btn rex-btn--bold rex-btn--sm active"
        >
          <span>от 1200$</span>
        </router-link>
      </div>
    </div>
    <div class="lk__content-item-footer">
      <router-link
        :to="{ name: 'Sale' }"
      >
        Спецпредложения
      </router-link>
    </div>
  </div>
</template>
